/* R-531 ① 모바일 하단 「인사책 바로 시작하기」 — 마크업 정본 src/lib/marketing-mobile-start-bar.ts · CSS src/styles/marketing-mobile-start-bar-css.ts.
   폰 판정은 CSS 가 한다(폭·pointer:coarse) — 여기서는 스크롤 뒤 보이기 · 닫기(이 탭 동안) · 본문 여백만.
   막대 요소는 붙들지 않고 쓸 때마다 다시 찾는다(fragment-stale-capture-census — 최상위 요소 캡처 0). */
(() => {
  const barEl = () => document.querySelector('[data-ins-mstart]')
  if (!barEl()) return
  const CLOSED_KEY = 'ins-mstart-closed'
  const readClosed = () => { try { return sessionStorage.getItem(CLOSED_KEY) === '1' } catch { return false } }
  if (readClosed() || /(?:^|;\s*)app_client=1(?:;|$)/.test(document.cookie)) { barEl().remove(); return }

  /* 첫 화면의 40% 를 내려간 뒤 — 첫 화면은 본문(검색해서 찾던 답)이 먼저다. */
  const threshold = () => Math.round(window.innerHeight * 0.4)
  const sync = () => {
    const bar = barEl()
    if (!bar) { window.removeEventListener('scroll', sync); return }
    const show = window.scrollY > threshold()
    bar.classList.toggle('is-shown', show)
    document.body.classList.toggle('has-mstart', show)
  }
  sync()
  window.addEventListener('scroll', sync, { passive: true })

  const onClick = (e) => {
    const t = e.target
    if (!t || typeof t.closest !== 'function' || !t.closest('.ins-mstart__close')) return
    try { sessionStorage.setItem(CLOSED_KEY, '1') } catch { /* 저장 못 해도 이번 화면에서는 닫는다 */ }
    window.removeEventListener('scroll', sync)
    document.removeEventListener('click', onClick)
    const bar = barEl()
    if (bar) bar.remove()
    document.body.classList.remove('has-mstart')
  }
  document.addEventListener('click', onClick)
})()
